"use strict";

module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.listColumns.hasOwnProperty(column);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/is-list-filter.js
// module id = Pwwa
// module chunks = 0